import React from 'react';
import { Button } from 'react-bootstrap';
import { MeteorologyViewMode } from 'redux/reducers/meteorologyFieldsObservedDataControlPanelReducer';

export interface VisualizationOption {
  value: MeteorologyViewMode;
  label: string;
  disabled?: boolean;
}

export default function VisualizationSelector({
  value,
  onChange,
  options,
}: {
  value: MeteorologyViewMode;
  onChange: (next: MeteorologyViewMode) => void;
  options: VisualizationOption[];
}) {
  return (
    <>
      {options.map((option) => {
        const activeStyle = value === option.value ? 'btn-control-panel-active' : '';
        return (
          <Button
            key={option.value}
            variant="link"
            disabled={option.disabled}
            onClick={() => onChange(option.value)}
            className={`btn-control-panel ${activeStyle}`}
          >
            {option.label}
          </Button>
        );
      })}
    </>
  );
}
